import React, { useContext } from 'react';
import styles from './index.module.scss';
import 'swiper/css';
import 'swiper/css/pagination';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const shopLink = {
  rozetka:
    'https://rozetka.com.ua/ua/sigareti/c4638591/price=625-1350;producer=b84d5fce/?utm_source=PMUsmsLM_fc_jun',
  cigPoshta:
    'https://cig-poshta.in.ua/shop/lm/swoof/price-0-to-1250/?utm_source=CDAsmsLM_fc_jun'
};

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <img
          className={styles.bg}
          src={getImageFromS3('images/sms-lm-fc/bg.png')}
          alt="container-bg"
        />
        <div className={styles.packContainer}>
          <img
            className={styles.logo}
            src={getImageFromS3('images/sms-lm-fc/logo.png')}
            alt="logo"
          />
        </div>
        <img
          className={styles.packsMain}
          src={getImageFromS3('images/sms-lm-fc/packs.png')}
          alt="packs"
        />
        <div className={styles.characteristicContainer}>
          <div className={styles.qualityContainer}>
            <img
              style={{ width: '100%', zIndex: 1, position: 'relative' }}
              src={getImageFromS3('images/sms-lm-fc/quality.png')}
              alt="quality"
            />
            <div className={styles.leafContainer}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="137"
                height="137"
                viewBox="0 0 137 137"
                fill="none"
              >
                <g clipPath="url(#clip0_3_425)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M51.4071 41.3832L52.9034 41.5455L52.9034 65.7018L51.4071 64.2056L51.4071 41.3832ZM44.5208 41.0948L45.999 41.0948L46.017 58.8154L44.5388 57.3372L44.5388 41.0768L44.5208 41.0948ZM32.2623 45.0607L29.9188 42.7172C30.6759 42.5369 31.4511 42.3747 32.2623 42.2125L32.2623 45.0607ZM65.1618 44.0332L66.6401 44.5019L66.6401 79.4745L65.1438 77.9783L65.1618 44.0332ZM37.6344 41.4193L39.1307 41.2931L39.1307 51.9291L37.6524 50.4509L37.6344 41.4193ZM58.2755 42.3386L59.7537 42.6631L59.7537 72.5882L58.2574 71.0919L58.2755 42.3386ZM92.6712 62.3127C93.194 62.9797 93.6807 63.6467 94.1495 64.3317L94.1495 106.984L92.6532 105.488L92.6712 62.3127ZM72.0302 46.539L73.5264 47.206L73.5264 86.3249L72.0302 84.8286L72.0302 46.539ZM99.5396 75.1661C100.225 77.2933 100.693 79.3844 101.018 81.4395L101.018 94.5272C100.639 97.033 100.116 99.3224 99.5396 101.305L99.5396 75.1661ZM78.8985 50.0903L80.3948 51.0097L80.3948 93.1932L78.9165 91.715L78.8985 50.0903ZM85.7849 55.1019L87.2811 56.4178L87.2811 100.08L85.8029 98.6013L85.7849 55.1019ZM49.8388 70.0644L19.3729 70.0644L18.796 67.0358L46.8102 67.0358L49.8388 70.0644ZM42.9524 63.178L18.2192 63.178L17.9307 60.1495L39.9599 60.1495L42.9885 63.178L42.9524 63.178ZM56.7071 76.9327L21.3018 76.9327C20.9773 75.9232 20.6528 74.9137 20.3644 73.9042L53.7146 73.9042L56.7432 76.9327L56.7071 76.9327ZM29.1977 49.4233L17.8586 49.4053L18.129 46.3948L26.1691 46.3948L29.1977 49.4233ZM36.066 56.2917L17.7144 56.2917C17.6964 55.2641 17.6603 54.2546 17.6784 53.2631L33.0375 53.2631L36.066 56.2917ZM80.6652 108.282C74.0853 110.643 62.0071 113.348 49.2619 108.282L80.6652 108.282ZM19.3188 39.5444L22.3113 42.537L18.6699 42.537C18.8682 41.5094 19.0665 40.4819 19.3188 39.5444ZM84.2165 104.442L41.8888 104.442C40.5187 103.541 39.1487 102.531 37.7966 101.432L81.1879 101.414L84.2165 104.442ZM77.3301 97.5558L33.6324 97.5558C32.6769 96.6003 31.7756 95.5547 30.9283 94.5272L74.3016 94.5272L77.3301 97.5558ZM70.4618 90.6874L28.062 90.6874C27.395 89.6959 26.746 88.6864 26.1511 87.6589L67.4332 87.6589L70.4618 90.6874ZM63.5754 83.8011L24.096 83.8011C23.6093 82.8096 23.1586 81.782 22.744 80.7905L60.5469 80.7725L63.5754 83.8011Z"
                    fill="url(#paint0_linear_3_425)"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_3_425"
                    x1="48.6184"
                    y1="42.1239"
                    x2="38.6007"
                    y2="100.634"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#0052A1" />
                    <stop offset="1" stopColor="#0F0D5C" />
                  </linearGradient>
                  <clipPath id="clip0_3_425">
                    <rect
                      width="137"
                      height="137"
                      fill="white"
                      transform="matrix(-1 0 0 1 137 0)"
                    />
                  </clipPath>
                </defs>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="137"
                height="137"
                viewBox="0 0 137 137"
                fill="none"
              >
                <g clipPath="url(#clip0_3_424)">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M85.5929 41.3832L84.0966 41.5455L84.0966 65.7018L85.5929 64.2056L85.5929 41.3832ZM92.4792 41.0948L91.001 41.0948L90.983 58.8154L92.4612 57.3372L92.4612 41.0768L92.4792 41.0948ZM104.738 45.0607L107.081 42.7172C106.324 42.5369 105.549 42.3747 104.738 42.2125L104.738 45.0607ZM71.8382 44.0332L70.3599 44.5019L70.3599 79.4745L71.8562 77.9783L71.8382 44.0332ZM99.3656 41.4193L97.8693 41.2931L97.8693 51.9291L99.3476 50.4509L99.3656 41.4193ZM78.7245 42.3386L77.2463 42.6631L77.2463 72.5882L78.7426 71.0919L78.7245 42.3386ZM44.3288 62.3127C43.806 62.9797 43.3193 63.6467 42.8505 64.3317L42.8505 106.984L44.3468 105.488L44.3288 62.3127ZM64.9698 46.539L63.4736 47.206L63.4736 86.3249L64.9698 84.8286L64.9698 46.539ZM37.4604 75.1661C36.7754 77.2933 36.3067 79.3844 35.9822 81.4395L35.9822 94.5272C36.3608 97.033 36.8836 99.3224 37.4604 101.305L37.4604 75.1661ZM58.1015 50.0903L56.6052 51.0097L56.6052 93.1932L58.0835 91.715L58.1015 50.0903ZM51.2151 55.1019L49.7189 56.4178L49.7189 100.08L51.1971 98.6013L51.2151 55.1019ZM87.1612 70.0644L117.627 70.0644L118.204 67.0358L90.1898 67.0358L87.1612 70.0644ZM94.0476 63.178L118.781 63.178L119.069 60.1495L97.0401 60.1495L94.0115 63.178L94.0476 63.178ZM80.2929 76.9327L115.698 76.9327C116.023 75.9232 116.347 74.9137 116.636 73.9042L83.2854 73.9042L80.2568 76.9327L80.2929 76.9327ZM107.802 49.4233L119.141 49.4053L118.871 46.3948L110.831 46.3948L107.802 49.4233ZM100.934 56.2917L119.286 56.2917C119.304 55.2641 119.34 54.2546 119.322 53.2631L103.963 53.2631L100.934 56.2917ZM56.3348 108.282C62.9147 110.643 74.9929 113.348 87.7381 108.282L56.3348 108.282ZM117.681 39.5444L114.689 42.537L118.33 42.537C118.132 41.5094 117.934 40.4819 117.681 39.5444ZM52.7835 104.442L95.1112 104.442C96.4813 103.541 97.8513 102.531 99.2034 101.432L55.8121 101.414L52.7835 104.442ZM59.6699 97.5558L103.368 97.5558C104.323 96.6003 105.224 95.5547 106.072 94.5272L62.6984 94.5272L59.6699 97.5558ZM66.5382 90.6874L108.938 90.6874C109.605 89.6959 110.254 88.6864 110.849 87.6589L69.5668 87.6589L66.5382 90.6874ZM73.4246 83.8011L112.904 83.8011C113.391 82.8096 113.841 81.782 114.256 80.7905L76.4531 80.7725L73.4246 83.8011Z"
                    fill="url(#paint0_linear_3_424)"
                  />
                </g>
                <defs>
                  <linearGradient
                    id="paint0_linear_3_424"
                    x1="88.3816"
                    y1="42.1239"
                    x2="98.3993"
                    y2="100.634"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#D90026" />
                    <stop offset="1" stopColor="#910018" />
                  </linearGradient>
                  <clipPath id="clip0_3_424">
                    <rect width="137" height="137" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p>
              <b>Якісний тютюн</b>
              <br />
              за більш доступною ціною в лінійці L&M
            </p>
          </div>
          <img
            style={{
              width: '100%',
              zIndex: 1,
              position: 'relative',
              marginTop: 30
            }}
            src={getImageFromS3('images/kv7/filter.png')}
            alt="filter"
          />
          <img
            style={{
              width: '100%',
              zIndex: 1,
              position: 'relative',
              marginTop: 20
            }}
            src={getImageFromS3('images/sms-lm-fc/qr.png')}
            alt="qr"
          />
          <div className={styles.surveyContainer}>
            <p className={styles.title}>Де купити?</p>
            <p className={styles.description}>
              Актуальний асортимент можна знайти у роздрібних точках продажу в
              твоєму місті або на офіційних онлайн сервісах, зокрема:
            </p>
            <div className={styles.buttonContainer}>
              <button
                onClick={() => {
                  sendEvent('rozetka');
                  window.open(shopLink.rozetka, '_blank');
                }}
              >
                Rozetka
              </button>
              <button
                onClick={() => {
                  sendEvent('Cig-Poshta');
                  window.open(shopLink.cigPoshta, '_blank');
                }}
              >
                Cig-poshta
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає
        <br /> серйозні захворювання
        <br /> та залежність
        <br /> Дана інформація про
        <br />
        продукт надається
        <br /> відповідно
        <br /> до статті 15 Закону
        <br /> України «Про захист
        <br />
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні.
        <br />
        <a href="/unsubscribe?returnLink=25-sms-lm-fc">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
